/* eslint-disable react-native/no-inline-styles */
/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useCallback, useRef, useState } from 'react';
import { StyleSheet, View, TouchableOpacity } from 'react-native';
import { useSelector, useDispatch } from 'react-redux';
import { showAlert } from '@/store/global';

import SociollaText from '@components/sociolla/SociollaText';
import SociollaTable from '@components/sociolla/SociollaTable';
import Image from '@components/global/Image';

import Colors from '@global/colors';
import { isWeb } from '@global/screens';
import tableApi from '@/hooks/tableApi';
import useApi from '@/hooks/useApi';
import {
  getPriceRulesProduct,
  getPriceRulesProductCount,
  deletePriceRulesProducts,
} from '@api/ms-catalog';
import { escapeRegexChars } from '@global/helpers';
import { useFocusEffect } from '@react-navigation/native';

const HEADER_DEKSTOP = [
  {
    label: 'Image',
    data: 'image',
    type: 'image',
    width: '10%',
    styleItem: {
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
  },
  {
    label: 'Product Name',
    data: 'ref_name',
    width: '30%',
  },
  {
    label: 'Reference',
    data: 'reference',
    width: '20%',
  },
  {
    label: 'EAN',
    data: 'ean_no',
    width: '15%',
  },
  {
    label: 'Sales Price',
    data: 'final_price',
    type: 'price',
    width: '15%',
  },
  {
    label: 'VAT',
    data: 'vat',
    type: 'vat',
    width: '10%',
  },
];

const HEADER_DEKSTOP_EDIT = [
  {
    label: 'Image',
    data: 'image',
    type: 'image',
    width: '10%',
    styleItem: {
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
  },
  {
    label: 'Product Name',
    data: 'ref_name',
    width: '25%',
  },
  {
    label: 'Reference',
    data: 'reference',
    width: '20%',
  },
  {
    label: 'EAN',
    data: 'ean_no',
    width: '15%',
  },
  {
    label: 'Price',
    data: 'sales_price',
    type: 'price',
    width: '15%',
  },
  {
    label: 'Vat',
    data: 'vat',
    type: 'vat',
    width: '10%',
  },
  {
    label: '',
    data: '',
    type: 'action',
    action: [
      {
        icon: require('@assets/img/icons/trash-grey.svg'),
        name: 'remove',
      },
    ],
    width: '5%',
  },
];

const defaultPhoto = require('@/assets/img/default/user-default.png');

function PricelistProduct(props) {
  const isAbleSearch = !!(props.showSearch ?? !props.isEditMode);

  const { list, setList } = props;
  const tableRef = useRef();
  const didFetchRef = useRef(false);

  const productRules = tableApi(
    getPriceRulesProductCount,
    getPriceRulesProduct,
  );
  const removePriceRulesProducts = useApi(deletePriceRulesProducts);

  const [loadingMore, setLoadingMore] = useState(false);
  const [paramsTable, setParamsTable] = useState({
    filter: {},
    limit: isWeb ? 10 : 15,
    skip: 0,
  });

  const dispatch = useDispatch();
  const paramsState = useSelector((state) => state.params);

  const renderItem = ({ item, index }) => (
    <TouchableOpacity
      //onPress={() => (props.isEditMode ? null : props.handleProductClick(item))}
      key={'list-product-' + index}
      style={styles.tableRow}>
      <View
        style={{ flexDirection: 'row', width: '100%', alignItems: 'center' }}>
        <View style={{ width: '20%' }}>
          <Image
            source={{ uri: `${item.image ? item.image : defaultPhoto}` }}
            style={{ width: 36, height: 36 }}
            width={36}
            height={36}
            defaultSource={defaultPhoto}
          />
        </View>
        <View style={{ width: '60%' }}>
          <SociollaText
            type="medium"
            style={{ fontSize: 14, color: Colors.black1, paddingBottom: 8 }}
            numberOfLines={1}>
            {item.name}
          </SociollaText>
          <SociollaText
            style={{ fontSize: 12, color: Colors.black5, paddingBottom: 9 }}>
            {item.reference}
          </SociollaText>
          <SociollaText
            type="medium"
            style={{ fontSize: 14, color: Colors.black1 }}
            currency={true}>
            {item.sales_price}
          </SociollaText>
        </View>
        {props.isEditMode && (
          <TouchableOpacity
            onPress={() => callBackAction({ name: 'remove', index })}
            style={{ position: 'absolute', right: 15, top: 15 }}>
            <Image
              width={20}
              height={20}
              svg={true}
              source={require('@assets/img/icons/trash-grey.svg')}
              style={{ height: 20, width: 20 }}
            />
          </TouchableOpacity>
        )}
      </View>
    </TouchableOpacity>
  );

  const generateData = (data) => {
    return (data || []).map((pr) => {
      const ref_name = pr.reference
        ? '[' + pr.reference + '] ' + pr.name
        : pr.name;
      return {
        ...pr,
        ref_name,
        sales_price: pr.final_price,
        vat: pr.vat,
        image: pr.image || '',
      };
    });
  };

  const callBackAction = (data) => {
    if (data.name === 'remove') {
      dispatch(
        showAlert({
          show: true,
          title: 'Remove Product',
          description: 'This product will be deleted. Do you want to proceed?',
          onCallback: async (val) => {
            try {
              const product = list[data.index];
              await removePriceRulesProducts.request(
                props.id,
                product.id,
                product.product_combination_id,
              );
            } catch (e) {
              console.log(e);
            }
            setEmpty(list.length - 1);
            setList(null, data.index);
          },
        }),
      );
    }
  };

  const setEmpty = (len) => {
    if (len === 0 && !paramsState.filter['$or']) {
      props.setEmpty(true);
    } else {
      props.setEmpty(false);
    }
  };

  const onSearchTable = async (param, type) => {
    let params = { ...paramsTable };
    if (type === 'keyword') {
      if (param.keyword.length > 2) {
        params.filter['$or'] = [
          {
            name: { $regex: escapeRegexChars(param.keyword), $options: 'i' },
          },
          {
            reference: { $regex: param.keyword, $options: 'i' },
          },
          {
            'brand.name': {
              $regex: escapeRegexChars(param.keyword),
              $options: 'i',
            },
          },
          {
            ean_no: { $regex: param.keyword, $options: 'i' },
          },
        ];
      } else if (!param.keyword) {
        delete params.filter['$or'];
        // setList([], -1);
        // return;
      }
    } else if (type === 'pagination') {
      setLoadingMore(true);
      params.limit = param.limit;
      params.skip = param.skip;
    } else if (type === 'reset') {
      params = {
        filter: {},
        limit: isWeb ? 10 : 15,
        skip: 0,
      };
    }
    await setParamsTable({ ...params });
    getTableData(params);
  };

  const getTableData = (params = null) => {
    const param = params ? params : { ...paramsTable };
    productRules.request(param, props.id).then((response) => {
      if (response) {
        let gen = [];
        if (param.skip > 0 && !isWeb) {
          gen = [...list, ...generateData(response)];
        } else {
          gen = generateData(response);
        }
        if (!params) {
          setEmpty(gen.length);
        }
        setList([...gen], -1, params);
        setLoadingMore(false);
      }
    });
  };

  useFocusEffect(
    useCallback(() => {
      if (!didFetchRef.current) {
        didFetchRef.current = true;
        if (props.id) {
          getTableData();
        }
      }

      return () => {
        didFetchRef.current = false;
      };
    }, [props.id]),
  );

  return (
    <View style={props.style}>
      {isWeb && ((list && list.length > 0) || paramsTable.filter['$or']) && (
        <SociollaTable
          table={props.isEditMode ? HEADER_DEKSTOP_EDIT : HEADER_DEKSTOP}
          ref={tableRef}
          datas={list}
          showSearch={isAbleSearch}
          searchBorder={true}
          showPagination={true}
          searchPlaceholder="Search by Name, Reference, EAN"
          searchKey={['name', 'reference']}
          count={productRules.count}
          loading={productRules.loading}
          callBackAction={callBackAction}
          callBackRowPress={(data) => props.handleProductClick(data)}
          onSearchTable={(val, type) => onSearchTable(val, type)}
          localParams={paramsTable}
        />
      )}
      {!isWeb && (
        <SociollaTable
          datas={list}
          count={productRules.count}
          itemComponent={renderItem}
          loading={productRules.loading}
          scrollItem={true}
          searchPlaceholder="Search by Name, Reference, EAN"
          searchKey={['name', 'reference']}
          loadingLoadMore={loadingMore}
          onSearchTable={(val, type) => onSearchTable(val, type)}
          localParams={paramsTable}
        />
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  tableRow: {
    justifyContent: 'center',
    alignItems: 'flex-start',
    flexDirection: 'column',
    height: 90,
    width: '100%',
    flex: 1,
    borderBottomColor: Colors.grey9,
    borderBottomWidth: 1,
    paddingHorizontal: 20,
    paddingVertical: 7,
  },
});

export default PricelistProduct;
